import React from "react";
import "./header.css";
import Slider from "react-slick";
import test from "../../assets/nerbanner/test1.png";
import test1 from "../../assets/nerbanner/test2.png";
import test2 from "../../assets/nerbanner/test3.png";


const testimonials = [
    {
        text: "Outstanding support and placement services. We found skilled testing talent faster than ever!",
        author: "Priya Saravanan, QA Lead"
    },
    {
        text: "Triplette made my job search incredibly easy and stress-free. They matched me with a Software Testing role that perfectly fit my skills.",
        author: "Karthik Ramesh, Software Tester"
    },
    {
        text: "I was impressed with how professional and proactive the Triplette team was throughout the hiring process for my QA role.",
        author: "Anand Kumar, Senior Test Engineer"
    },
    {
        text: "Triplette is more than just a placement firm—they genuinely cared about my testing career and helped me land a stable job.",
        author: "Lakshmi Narayanan, Test Manager"
    },
    {
        text: "Thanks to Triplette, I found a great opportunity in Software Testing much faster than expected. Their team is friendly and transparent.",
        author: "Sivakumar Rajan, Automation Tester"
    },
    {
        text: "The experience with Triplette was seamless. They prepared me for interviews and connected me with top-tier IT testing companies.",
        author: "Arun Prasad, QA Automation Engineer"
    },
    // ✅ Extra 10 focused on testing
    {
        text: "Triplette guided me into a Manual Testing role and supported me with interview preparation.",
        author: "Meena Krishnan, Manual Tester"
    },
    {
        text: "Their resume-building session highlighted my QA skills, which gave me a strong edge in interviews.",
        author: "Vigneshwaran S, Junior Test Engineer"
    },
    {
        text: "I transitioned from ITES to Software Testing smoothly with Triplette’s mentoring and guidance.",
        author: "Deepa Manohar, Software Tester"
    },
    {
        text: "The Triplette team connected me with a company where I could grow as an Automation Tester.",
        author: "Rajesh Kannan, Selenium Test Engineer"
    },
    {
        text: "Triplette’s continuous follow-ups and guidance gave me confidence to secure my testing job.",
        author: "Gayathri S, QA Engineer"
    },
    {
        text: "Their transparent communication helped me clearly understand my strengths as a Software Tester.",
        author: "Mohan Kumar, Test Analyst"
    },
    {
        text: "Triplette’s mentoring sessions were practical and tailored to my software testing career needs.",
        author: "Revathi Natarajan, QA Consultant"
    },
    {
        text: "They helped me switch from Manual Testing to Automation Testing with proper training and placement.",
        author: "Sathish Kumar, Automation Engineer"
    },
    {
        text: "Thanks to Triplette, I joined a reputed IT company as a Software Tester within weeks.",
        author: "Nandhini Selvaraj, Test Engineer"
    },
    {
        text: "Triplette made my job search in the QA field stress-free and helped me land my dream role.",
        author: "Harish Balaji, Quality Analyst"
    }
];


function Header() {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000, // 3 seconds for each testimonial
    };
    return (
        <section className="why-choose-section">
            <div className="custom-container">
                <div className="custom-row">
                    {/* Left Content */}
                    <div className="left-content">
                        <div className="content-wrapper">
                            <div className="section-header">
                                <div className="section-title">
                                    <div className="title-header">
                                        {/* <h5 className="subtitle">WHO WE SERVE</h5> */}
                                        <h1 className="main-title">Position Hiring for IT and IT Excellence</h1>
                                    </div>
                                    {/* <div className="underline" style={{ color:"white"}}></div> */}
                                </div>
                                <p className="description">
                                    At Triplette, we are committed to helping aspiring and returning professionals launch or relaunch their careers in the dynamic IT and ITES sectors. Whether you are a fresher stepping out of college, an experienced professional seeking growth, or someone returning to the workforce after a break — we are here to guide you every step of the way.

                                </p>
                                <p className="description">Our tailored solutions go beyond just job matching — we offer comprehensive IT consultancy, technical training, and project support to ensure you're industry-ready and confident.
                                </p>
                                <a href="tel:8072712418" className="btn get-button">Get Guidence</a>
                            </div>
                        </div>
                    </div>

                    {/* Right Review Box */}
                    <div className="right-review">
                        <div className="review-card">
                           <div className="img-test">
                           <img src={test} className="img-testimg"/>
                            </div>
                            <Slider {...settings}>
                                {testimonials.map((testimonial, index) => (
                                    <div key={index} className="">
                                        <h4>
                                            What Client Say's
                                        </h4>
                                        <p>"{testimonial.text}"</p>
                                        <p>- {testimonial.author}</p>
                                        <div className="stars">
                                            <span className="fa fa-star checked"></span>
                                            <span className="fa fa-star checked"></span>
                                            <span className="fa fa-star checked"></span>
                                            <span className="fa fa-star checked"></span>
                                            <span className="fa fa-star checked"></span>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default Header;
